function handleBuildStockAvailabilityUI(data) {
  const availabilityAccordionWrapper = document.querySelector('.js-stock-availability-accordion-wrapper')
  const availabilityContainer = document.querySelector('.js-availability-container')

  let availabilityBoxes = ''
  data?.ShopAvailable?.forEach((shop, idx) => {
    let statusEl = '<span class="availability-status availability-status--available">In stock</span>'
    if (shop.QTY_Status === 'N') {
      statusEl = '<span class="availability-status availability-status--unavailable">Out of stock</span>'
    } else if (shop.QTY_Status === 'L') {
      statusEl = '<span class="availability-status availability-status--low">Low stock</span>'
    }
    availabilityBoxes += `
    <div class="availability-box">
      <div class="availability-header">
        ${statusEl}
      </div>
      <div class="availability-body">
        <span class="availability-name">${shop.Shop_Name}</span>
        <span class="availability-address">${shop.Shop_address}</span>
        <span class="availability-tel">${shop.Shop_tel}. </span>
        ${shop.ShopWa ? `<a href="${shop.ShopWa}" target="_blank" class="availability-whatsapp">Contact store</a>` : ''}
      </div>
    </div>
    `
  })
  
  if (!availabilityBoxes) {
    availabilityAccordionWrapper.style.display = 'none'
    return
  }
  availabilityContainer.innerHTML = availabilityBoxes
  setTimeout(() => {
    const bodyMask = document.querySelector('.accordion__body--show-a-part .js-stock-availability-accordion__body-mask');
    console.log(data?.ShopAvailable?.length, 'data?.ShopAvailable?.length')
    if (data?.ShopAvailable?.length <= 2) {
      if (bodyMask) bodyMask.style.display = 'none'
    } else {
      console.log(bodyMask, 'bodyMask')
      if (bodyMask) bodyMask.style.display = 'block'
    }
  }, 500)
}

function handleStockAvailability() {
  const API_TOKEN = '9dafdasf3dafdfdas584adsfsdafdsh78'
  const availabilityContainer = document.querySelector('.js-availability-container')
  const sku = availabilityContainer.dataset.sku

  fetch(`https://wap.sidefame.com.hk/ECAPI/StockQty/V2/${sku}`, {
    method: 'GET',
    headers: {
      'Authorization': API_TOKEN,
      'Content-type': 'text/json'
    },
  })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    })
    .then(handleBuildStockAvailabilityUI)
    .catch(error => {
      // Handle errors here
      console.error('There was a problem with the fetch operation:', error);
      const availabilityAccordionWrapper = document.querySelector('.js-stock-availability-accordion-wrapper')
      availabilityAccordionWrapper.style.display = 'none'
    });
}

document.addEventListener('DOMContentLoaded', () => {
  handleStockAvailability()
})